import { REF_DATA, SELECTED_COUNTRY, COUNTRIES, RESET } from '../constants'

const referenceData = (state = [], action) => {
  switch (action.type) {
    case REF_DATA:
      return [...state, action]
    case SELECTED_COUNTRY:
      return [...state, action]
    case COUNTRIES:
      return [...state, action]
    case RESET :
      return {}
    default:
      return state
  }
}

export default referenceData



// WEBPACK FOOTER //
// ./src/reducers/referenceData.js